import { disableActiveNavItem, enableNavItem, getAnchors, hideAnchorNav, showAnchorNav } from './modules/helper';
import { classes, selectors } from './modules/init';

const anchorNav = document.querySelector(selectors.nav);

const setHighlightColorScheme = () => anchorNav.setAttribute('data-color-scheme', 'highlight');
const removeHighlightColorScheme = () => anchorNav.removeAttribute('data-color-scheme');

if (anchorNav) {
	const anchors = getAnchors(anchorNav);
	const navItemStates = {};
	anchors.forEach((anchor) => (navItemStates[anchor.id] = false));
	// * Initialize IntersectionObserver which observes all sections with a anchor
	const observer = new IntersectionObserver(
		(entries) => {
			for (let i = 0; i < entries.length; i++) {
				const entry = entries[i];
				const entryId = entry.target.id;
				if (entry.isIntersecting) {
					navItemStates[entryId] = entry.intersectionRatio;
				} else if (navItemStates[entryId] !== false) {
					navItemStates[entryId] = false;
				}
			}
			let maxIntersectionRatio = 0;
			let activeNavItem = false;
			for (let id in navItemStates) {
				if (navItemStates[id] !== false && navItemStates[id] > maxIntersectionRatio) {
					activeNavItem = id;
					maxIntersectionRatio = navItemStates[id];
				}
			}
			activeNavItem ? enableNavItem(anchorNav.querySelector(`li[data-target="${activeNavItem}"]`)) : disableActiveNavItem();
		},
		{
			threshold: [0, 0.25, 0.5, 0.75, 1], // Run the callback every time visibility passes another 25%
		},
	);

	// * Observe elements
	anchors.forEach((anchor) => observer.observe(anchor));

	// Build a second Observer which is observing all sections
	const highlightSectionObserverCallback = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.intersectionRatio > 0.25 ? setHighlightColorScheme() : removeHighlightColorScheme();
			}
		});
	};

	const colorObserver = new IntersectionObserver(highlightSectionObserverCallback, {
		threshold: [0, 0.25, 0.5, 0.75, 1],
		rootMargin: '-150px 0px -200px 0px',
	});
	document.querySelectorAll(selectors.highlightSection).forEach((section) => colorObserver.observe(section));

	// Hide anchor navigation when footer comes in viewport
	const footer = document.querySelector(selectors.footer);
	if (footer) {
		const footerObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						hideAnchorNav(anchorNav);
					} else {
						showAnchorNav(anchorNav);
					}
				});
			},
			{
				rootMargin: `0px 0px ${-0.5 * window.innerHeight}px 0px`,
			},
		);
		footerObserver.observe(footer);
	}

	// Show anchor navigation
	// TODO: Show anchor navigation below header
	anchorNav.classList.add(classes.show);
}
